import Vue from 'vue';
import Router from 'vue-router'
// import UserHome from '../views/humanResource/more.vue'
Vue.use(Router)

//缓存原来的push、replace
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

//增强push
Router.prototype.push = function(location,okCallback,errCallback){
if(okCallback === undefined && errCallback === undefined){
	return originalPush.call(this,location).catch(()=>{})
}else{
	return originalPush.call(this,location,okCallback,errCallback)
}
}
//增强replace
Router.prototype.replace = function(location,okCallback,errCallback){
if(okCallback === undefined && errCallback === undefined){
	return originalReplace.call(this,location).catch(()=>{})
}else{
	return originalReplace.call(this,location,okCallback,errCallback)
}
}


let routers = new Router({
  mode: 'hash',
  routes: [
    {
      path:"/",
      name:'index',
      meta:{keepAlive:true},
      component: () => import('../views/index')
    },
    {
      path:"/humanResource",
      name:'humanResource',
      meta:{keepAlive:true},
      component: () => import('../views/humanResource'),
      // children: [{ path: 'more', components: () => import('../views/humanResource/more.vue') }],
    },
    {
      path:"/humanmore",
      name:'humanmore',
      meta:{keepAlive:true},
      component: () => import('../views/humanResource/more'),
      // children: [{ path: 'more', components: () => import('../views/humanResource/more.vue') }],
    },
    {
      path:"/pressCenter",
      name:'pressCenter',
      meta:{keepAlive:true},
      component: () => import('../views/pressCenter')
    },
    {
      path:"/allNews",
      name:'allNews',
      meta:{keepAlive:true},
      component: () => import('../views/allNews')
    },
    {
      path:"/research",
      name:'research',
      meta:{keepAlive:true},
      component: () => import('../views/research')
    },
    {
      path:"/searchResult",
      name:'searchResult',
      meta:{keepAlive:true},
      component: () => import('../views/searchResult')
    },
    {
      path:"/loveXiuZheng",
      name:'loveXiuZheng',
      meta:{keepAlive:true},
      component: () => import('../views/loveXiuZheng')
    },
    {
      path:"/alllove",
      name:'alllove',
      meta:{keepAlive:true},
      component: () => import('../views/loveXiuZheng/alllove')
    },
    {
      path:"/groupProducts",
      name:'groupProducts',
      meta:{keepAlive:true},
      component: () => import('../views/groupProducts')
    },
    {
      path:"/partyConstruction",
      name:'partyConstruction',
      meta:{keepAlive:true},
      component: () => import('../views/partyConstruction')
    },
    {
      path:"/about",
      name:'about',
      meta:{keepAlive:true},
      component: () => import('../views/about')
    },
    {
      path:"/detail",
      name:'detail',
      component: () => import('../views/detail')
    },
    {
      path:"/recruitDetail",
      name:'recruitDetail',
      component: () => import('../views/humanResource/recruitDetail')
    },
    {
      path:"/leaderDetail",
      name:'leaderDetail',
      component: () => import('../views/humanResource/leaderDetail')
    },
    {
      path:"/convention",
      name:'convention',
      component: () => import('../views/convention')
    },
    
    // {
    //   path:"*",
    //   component: () => import('../views/index')
    // }
  ],
  scrollBehavior(to,from,savedPosition){
		if (savedPosition) {
			//能进入判断，就意味着用户绝对是通过浏览器的前进、后退按钮操作路由了
			return savedPosition //保留住跳转之前的位置
		} else {
			//用户是通过项目中的交互操作的路由，那么每次跳转滚动条都在最上方
			return { x: 0, y: 0 } 
		}
	}

})
routers.beforeEach((to, from, next) => { //输入不存在的路由，跳到指定的页面
  if (to.matched.length === 0) {
    next("/");
  } else {
    next();
  }
})

export default routers
